export default __webpack_public_path__ + "static/mobile-salebg-f5b82554c2eb5c1561577a67e124a195.jpg";